import { ComponentProps } from 'react';
import { Stack } from '../../../../design-system/stack/stack';
import { AccountView } from '../../../../types/entity-types';
import { isBankingAccount } from '../../../../utils/accounts/is-banking-account';
import { AccountMappingForm, ExternalBankAccount } from './account-mapping-form';

export type CreateAccountSelectOptionValue = 'create';

type AccountMappingModalContentProps = {
  xeroBankAccounts: ExternalBankAccount[];
  accounts: AccountView[];
} & Omit<ComponentProps<typeof AccountMappingForm>, 'xeroBankAccounts' | 'accounts'>;

export const AccountMappingModalContent = ({
  accounts,
  xeroBankAccounts,
  ...rest
}: AccountMappingModalContentProps) => {
  // Show all banking accounts - invoice payment tracking works with all account types (not just Modulr)
  const seapointAccounts = accounts.filter(isBankingAccount);
  const xeroBankAccountsWithCreateOption: ComponentProps<typeof AccountMappingForm>['xeroBankAccounts'] = [
    ...xeroBankAccounts.map((xeroBankAccount) => ({
      type: 'existing' as const,
      ...xeroBankAccount,
    })),
    { type: 'create', id: 'create', name: 'Create new account in Xero' },
  ];

  return (
    <Stack space={5} align="stretch" className="mx-auto mt-[100px] w-[950px]">
      <Stack space={2} align="stretch">
        <h1 className="text-xl leading-5 font-medium tracking-tight text-black">
          Select Xero accounts for each Seapoint account
        </h1>

        <p className="text-base leading-5 font-normal tracking-tight text-muted-foreground">
          Map your Seapoint accounts to Xero and choose how far back you'd like us to sync your transactions. You can
          update these at any time from your settings.
        </p>
      </Stack>

      <AccountMappingForm accounts={seapointAccounts} xeroBankAccounts={xeroBankAccountsWithCreateOption} {...rest} />
    </Stack>
  );
};
